module.exports = __webpack_public_path__ + "static/media/theBoatImg.6fc644f1.png";